module.exports = __webpack_public_path__ + "img/01.0ba053f7.gif";